import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ellipsis-animation',
  templateUrl: './ellipsis.animation.html',
  styleUrls: ['./ellipsis.animation.scss']
})
export class EsllipsisAnimation implements OnInit {

  @Input() message = '';

  constructor() { }

  ngOnInit() {
  }
}